import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRemediation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path d="M2.438 17.583a.75.75 0 0 1 .75-.75H16.75a.75.75 0 0 1 0 1.5H3.188a.75.75 0 0 1-.75-.75" />
    <path
      fillRule="evenodd"
      d="M16.035 6.5c-1.77 0-3.497 1.445-4.994 3.338-.745.942-1.584 1.982-2.69 2.756C7.186 13.41 5.796 13.89 4 13.89a1.5 1.5 0 0 1 0-3c1.203 0 1.989-.305 2.63-.753.698-.489 1.29-1.19 2.058-2.16 1.526-1.93 4.047-4.477 7.347-4.477a1.5 1.5 0 0 1 0 3"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRemediation;
